// Parte un título en palabras para la animación T1 (ver app/motion.css).
// El índice se limita para que un título largo no tarde más de
// 0,8 s + 12 × 70 ms en quedar entero.
export const MAX_STAGGER = 12;

// Cada palabra es un bloque propio, así que el navegador ya no aplica la regla
// de no cortar antes de «?», «!», «:», «;» o «»» (francés). Se pegan con un
// espacio de no separación y solo se parte por espacios normales.
const NBSP = " ";

export function splitWords(text) {
  return String(text ?? "")
    .replace(/[ \t\r\n]+(?=[?!:;»])/g, NBSP)
    .replace(/«[ \t\r\n]+/g, `«${NBSP}`)
    .trim()
    .split(/[ \t\r\n]+/)
    .filter(Boolean)
    .map((word, i) => ({ word, i: Math.min(i, MAX_STAGGER) }));
}
